import { ClaimFormState, excludeRemovedDocuments } from '../schema';
import { type ClaimSubmissionRequest, ViewClaimFilters } from 'all-in-one-shared-api';
import moment from 'moment';
import { SelectedClaimTypeObjectType } from '../hooks/useSelectedClaimTypeMapping';

export class NewClaimUtils {
  static mapClaimSubmission(data: ClaimFormState): ClaimSubmissionRequest {
    const otherMemberInfo = {
      anotherPolicyNumber: data.anotherPolicyNumber,
      anotherMemberId: data.anotherMemberId,
    };

    return {
      patientMemberType: data.patientMemberType || '',
      claimType: data.claimType === 'OP' ? data.claimType : (data?.claimTypeObject && data?.claimTypeObject[0]) || '',
      benefitCodes:
        data.claimType === 'OP' && data?.claimTypeObject
          ? data?.claimTypeObject?.map((claim) => claim.replace('__', ''))
          : [],
      fullClaim: !data.partialClaim || false,
      firstClaim: data.isFirstClaim || false,
      firstClaimWithGenerali: data.firstClaimWithGenerali || false,
      doctorId: data.doctorId || '',
      doctorName: data.doctorName,
      diagnosisCode: data.diagnosisCode || '',
      treatmentDate:
        typeof data.treatmentDate === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(data.treatmentDate)
          ? data.treatmentDate
          : moment(data.treatmentDate).format('DD/MM/YYYY') || '',
      receiptAmounts:
        data?.receiptAmounts?.map((o) => ({
          amount: o,
          currency: data.currency,
        })) ?? [],
      receipts: excludeRemovedDocuments(data?.receipts),
      referralLetters: excludeRemovedDocuments(data?.referralLetters),
      otherDocuments: excludeRemovedDocuments(data?.otherDocuments),
      prevClaimSettlements: excludeRemovedDocuments(data?.prevClaimSettlements),
      otherInsurerName: data.otherInsurerName || '',
      otherClaimAmount: data?.firstClaimAmount
        ? {
            amount: data.firstClaimAmount || '',
            currency: data.firstClaimCurrency || '',
          }
        : undefined,
      ...otherMemberInfo,
    };
  }

  static mapViewClaimFilter(
    patientMemberType: string,
    selectedClaimTypeObject: SelectedClaimTypeObjectType,
  ): ViewClaimFilters {
    if (!selectedClaimTypeObject.type) return {};

    if (selectedClaimTypeObject.type === 'OP') {
      return {
        patientMemberTypes: [patientMemberType],
        benefitCodes: selectedClaimTypeObject.data.map((claim) => claim.code || ''),
        claimTypes: ['OP'],
      };
    }

    return {
      patientMemberTypes: [patientMemberType],
      claimTypes: selectedClaimTypeObject.data.map((claim) => claim.code || ''),
    };
  }
}
